export default __webpack_public_path__ + "static/media/earphones14.cd5c0118.jfif";